"use strict";
checkList.classy.controller({
    name: "PercentTuitionController",
    inject: [
        "$scope", "RestService", "ApplicationService", "FamilyThresholdsService", "AlertService", 
        "ResetService", "BinFactory"
    ],
    init: function() {
        this.$.ApplicationService = this.ApplicationService;
        this.$.ResetService = this.ResetService;
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        let fmThreshold = this.ApplicationService.getAwardData().family[0].thresholds;
        this.$.putObject = {
            Thresh_Fam1_Tuition_Percent: fmThreshold.Thresh_Fam1_Tuition_Percent,
            Thresh_Fam2_Tuition_Percent: fmThreshold.Thresh_Fam2_Tuition_Percent
        };
    },
    percentTuitionFinish: function() {
        let caseNo = "case85";
        let queue = [];
        // family 1
        this.$.putObject.familyID = this.ApplicationService.getAwardData().family[0].data[0].familyID;
        queue.push(this.FamilyThresholdsService.put(this.$.putObject));
        // family 2
        this.$.putObject.familyID = this.ApplicationService.getAwardData().family[1].data[0].familyID;
        queue.push(this.FamilyThresholdsService.put(this.$.putObject));
        this.$.alertPut(queue, caseNo, 0, this.$.putObject);

        this.ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam1_Tuition_Percent =
            this.$.putObject.Thresh_Fam1_Tuition_Percent;
        this.ApplicationService.getAwardData().family[0].thresholds.Thresh_Fam2_Tuition_Percent =
            this.$.putObject.Thresh_Fam2_Tuition_Percent;
        this.ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam1_Tuition_Percent =
            this.$.putObject.Thresh_Fam1_Tuition_Percent;
        this.ApplicationService.getAwardData().family[1].thresholds.Thresh_Fam2_Tuition_Percent =
            this.$.putObject.Thresh_Fam2_Tuition_Percent;
    }
});
